import { forwardRef, useImperativeHandle } from 'react';
import { UseFormReturn } from 'react-hook-form';
import { z } from 'zod';

import { FranchiseSalesOrganizationFormSchema } from '@/components/forms/schemas/FranchiseSalesOrganizationFormSchema';
import { FormRadioGroup } from '@/components/global/form-inputs/FormRadioGroup';
import { FormTextArea } from '@/components/global/form-inputs/FormTextArea';
import { Form } from '@/components/ui/form';
import { currentWorkingBrandsOptions, yesNoOptions } from '@/constants/options';

interface FranchiseSalesOrganizationFormProps {
  form: UseFormReturn<z.infer<typeof FranchiseSalesOrganizationFormSchema>>;
}

export const FranchiseSalesOrganizationForm = forwardRef<
  { submitForm: () => void },
  FranchiseSalesOrganizationFormProps
>(({ form }, ref) => {
  // imperative handle
  useImperativeHandle(ref, () => ({
    submitForm: () => {
      form.handleSubmit(() => Promise.resolve())();
    },
  }));

  return (
    <Form {...form}>
      <form className="w-full space-y-1.5">
        <div className="flex flex-col gap-6 rounded-xl border border-border bg-white p-6">
          <p className="as-title-03 as-strong w-[280px] text-zinc-700">
            Franchise Sales Organizations (FSOs)
          </p>
          <div className="w-full">
            <div className="grid flex-1 grid-cols-2 gap-6">
              <FormRadioGroup
                control={form.control}
                name="current_working_brands"
                label="Brands Currently Working With"
                options={currentWorkingBrandsOptions}
                className="col-span-2"
              />
              <FormRadioGroup
                control={form.control}
                name="have_any_fsos"
                label="Do you currently work with any FSOs?"
                options={yesNoOptions}
                className="col-span-2"
              />
              <FormTextArea
                control={form.control}
                type="textarea"
                name="detailed_answer"
                label="Explain Your Answer"
                className="col-span-2"
              />
            </div>
          </div>
        </div>
      </form>
    </Form>
  );
});

FranchiseSalesOrganizationForm.displayName = 'FranchiseSalesOrganizationForm';
